import React, { Component } from 'react';
import './PersonRegist.css'
import Api from '../../api/wxapi';
import intl from 'react-intl-universal';
import Select from 'react-select';
import { inject, observer } from 'mobx-react';


let Timer = null


@inject('store')
@observer
export default class PersonRegist extends Component {
  constructor(props) {
    super();
    this.state = {
      storename: '',
      storeadress: '',
      deveiceId: '',
      username: '',
      mobile: '',
      mobilecode: '',
      sendTime: 0

    };
    this.data = null

  }

  componentDidMount() {
    document.title = '技师认证'
    //先尝试从缓存中获得用户openid
    let userStr = sessionStorage.getItem('user');
    if (userStr && userStr.length > 0) {
      let data = JSON.parse(userStr)
      this.data = data
      if(!data.openid&&data.openid.length<=0){
        let openId =sessionStorage.getItem('openid')
        if(!openId&&openId.length<=0){
          window.location.location=this.props.store.rootUrl+'person/PersonCenter'
        }    
      } 
    }

  }
  render() {
    let {
      storename,
      storeadress,
      deveiceId,
      username,
      mobile,
      mobilecode,
      sendTime
    } = this.state

    return (
      <div style={{ paddingLeft: 12, paddingRight: 12, flex: 1, }}>

        <div className='itemContaier'>
          <p className='itemname'>{intl.get('txt_sbid')}</p>
          <input className="inputbox" type="text" value={deveiceId} onChange={event => this.setState({ deveiceId: event.target.value })} placeholder={'请输入使用设备ID'} />
        </div>

        <div className='itemContaier'>
          <p className='itemname'>{intl.get('txt_jsxm')}</p>
          <input className="inputbox" type="text" value={username} onChange={event => this.setState({ username: event.target.value })} placeholder={'请输入您的真实姓名'} />
        </div>

        <div className='itemContaier'>
          <p className='itemname'>{intl.get('txt_shoujhm')}</p>
          <input className="inputbox" type="text" value={mobile} onChange={event => this.setState({ mobile: event.target.value })} placeholder={'请输入手机号码'} />
        </div>

        <div className='itemContaier'>
          <p className='itemname'>{intl.get('txt_dxyzmm')}</p>

          <input className="inputbox  fleft" type="text" value={mobilecode} onChange={event => this.setState({ mobilecode: event.target.value })} placeholder={'请输入短信验证码'} />
          <button className="pr-buttong-getcode" style={{ backgroundColor: sendTime > 0 ? '#F7F7F7' : '#FFAD26' }} onClick={this.getcode}>{sendTime > 0 ? sendTime + 's' : '获取验证码'}</button>

        </div>


        <button className="pr-button" onClick={this.submit}>{'提交'}</button>
      </div>
    )
  }
  componentWillUnmount() {
    clearInterval(Timer);
  }

  getcode = () => {
    if (this.state.sendTime > 0) {
      return
    }

    let { mobile } = this.state
    if (mobile && mobile.length > 0) {
      if (this.isMobileNumber(mobile)) {
        Api.getPhoneCode({ mobile: mobile }).then(res => {
          if (res.data.code == 0) {
            this.Countdown()
          }
        })

      }

    }

  }

  submit = () => {
    let {

      deveiceId,
      username,
      mobile,
      mobilecode,
    } = this.state


    if (deveiceId && username && mobile && mobilecode) {
      let params = {

        mobile: mobile,
        name: username,
        device_number: deveiceId,
        code: mobilecode,
      }
      Api.postRegistMessage(params).then(res => {
        console.log(res)
        if (res.data.code == 0) {

          //更改缓存中的用户状态
          let userStr = sessionStorage.getItem('user');
          if (userStr && userStr.length > 0) {
            let data = JSON.parse(userStr)
            data.is_auth = true;
            sessionStorage.setItem('user', JSON.stringify(data))
          }
          let redirct = this.props.store.getQueryString('redirect')
          if (redirct) {
            this.props.history.push(redirct)
          } else {
            this.props.history.push(`/person/ShowResult?flag=true&type=${global.constants.regist}`)
          }

        } else {
          alert(res.data.message)
        }

      })

    } else {
      alert('请完善信息')
    }

  }


  isMobileNumber(phone) {
    let flag = false;
    let message = "";
    let myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
    if (phone == '') {
      // console.log("手机号码不能为空");
      message = "手机号码不能为空！";
    } else if (phone.length != 11) {
      //console.log("请输入11位手机号码！");
      message = "请输入11位手机号码！";
    } else if (!myreg.test(phone)) {
      //console.log("请输入有效的手机号码！");
      message = "请输入有效的手机号码！";
    } else {
      flag = true;
    }
    if (message != "") {
      alert(message);
    }
    return flag;
  }

  // 开始倒计时
  Countdown() {
    this.setState({
      sendTime: 60
    });
    Timer = setInterval(() => {
      let _sendTime = this.state.sendTime;
      if (_sendTime > 0) {
        this.setState({
          sendTime: --this.state.sendTime
        });
      } else {
        clearInterval(Timer);
      }
    }, 1000);
  }


}



// WEBPACK FOOTER //
// ./src/views/person/PersonRegist.js